import React from 'react';
import LegalPage from '../components/LegalPage';

const sections = [
    {
        title: 'Cum ne scrieți',
        items: [
            'La recepție, verbal sau în scris, pe formularul de sesizare.',
            'Pe e-mail, la contact@evoomedical.ro.',
            'Prin poștă, la sediul clinicii.'
        ]
    },
    {
        title: 'Ce urmează',
        items: [
            'Înregistrăm sesizarea și vă comunicăm numărul ei.',
            'Directorul medical sau Directorul General o analizează, după caz, și discută cu cei implicați.',
            'Primiți un răspuns scris în cel mult 30 de zile, cu ce s-a constatat și ce s-a schimbat.'
        ]
    },
    {
        title: 'Alte căi',
        text: 'Vă puteți adresa oricând și Direcției de Sănătate Publică Alba, Colegiului Medicilor Alba sau ANPC. Sesizarea către noi nu vă condiționează aceste drepturi.'
    }
];

function Sesizari() {
    return (
        <LegalPage
            eyebrow="Informații legale"
            title="Sesizări, reclamații și sugestii"
            intro="Vrem să aflăm când ceva nu a mers bine, la fel de mult ca atunci când a mers bine."
            sections={sections}
            footnote="EVOO-COM-MAN-01-R3 · versiunea din 25.10.2026"
        />
    );
}

export default Sesizari;
